import { defineComponent as _defineComponent } from 'vue'
import Vue, { computed, defineAsyncComponent, ref } from "vue";
import NetworkGraphCard from "@/components/visual-navigator/network-graph-card.vue";
import {
  BBreadcrumb,
  BIconList,
  BIconChevronDoubleLeft,
  BFormCheckbox,
  BIconFullscreen,
  BIconFullscreenExit,
  VBTooltip,
} from "bootstrap-vue";
import GraphLegend from "@/components/visual-navigator/graph/graph-legend.vue";
import useStore from "@/store/useStore";
import { useRoute, useRouter } from "vue-router/composables";
import { isString } from "@stellarbeat/js-stellarbeat-shared/lib/typeguards";

export default /*#__PURE__*/_defineComponent({
  __name: 'network-visual-navigator',
  props: {
  view: {
    type: String,
    default: "map",
  },
},
  setup(__props) {

const props = __props;

Vue.directive("b-tooltip", VBTooltip);
const WorldMap = defineAsyncComponent(
  () => import("@/components/visual-navigator/world-map.vue")
);


const view = computed(() => props.view);

const store = useStore();
const network = store.network;
const route = useRoute();
const router = useRouter();

const selectedNode = computed(() => {
  return store.selectedNode;
});

const selectedOrganization = computed(() => {
  return store.selectedOrganization;
});

const optionShowFailingEdges = ref(false);
const optionHighlightTrustingNodes = ref(true);
const optionHighlightTrustedNodes = ref(true);
const optionShowRegularEdges = ref(true);
const optionTransitiveQuorumSetOnly = ref(false);

const menuVisible = ref(false);
const fullScreen = ref(false);

const breadCrumbs = computed(() => {
  let crumbs = [];
  crumbs.push({
    text: store.getNetworkContextName(),
    to: {
      name: "network-dashboard",
      query: {
        view: route.query.view,
        network: route.query.network,
        at: route.query.at,
      },
    },
  });

  if (selectedNode.value) {
    if (
      selectedNode.value.organizationId &&
      network.getOrganizationById(selectedNode.value.organizationId)
    )
      crumbs.push({
        text: network.getOrganizationById(selectedNode.value.organizationId)
          .name,
        to: {
          name: "organization-dashboard",
          params: {
            organizationId: selectedNode.value.organizationId,
          },
          query: {
            view: route.query.view,
            network: route.query.network,
            at: route.query.at,
          },
        },
        active: false,
      });
    crumbs.push({
      text: selectedNode.value.displayName,
      active: true,
    });
  } else if (selectedOrganization.value)
    crumbs.push({
      text: selectedOrganization.value.name,
      active: true,
    });
  return crumbs;
});

function navigateToView() {
  let toView = view.value === "map" ? "graph" : "map";
  router.push({
    name: route.name ? route.name : undefined,
    params: route.params,
    query: {
      view: toView,
      "no-scroll": "1",
      network: route.query.network,
      at: route.query.at,
    },
  });
}

return { __sfc: true,WorldMap, props, view, store, network, route, router, selectedNode, selectedOrganization, optionShowFailingEdges, optionHighlightTrustingNodes, optionHighlightTrustedNodes, optionShowRegularEdges, optionTransitiveQuorumSetOnly, menuVisible, fullScreen, breadCrumbs, navigateToView, NetworkGraphCard, BBreadcrumb, BIconList, BIconChevronDoubleLeft, BFormCheckbox, BIconFullscreen, BIconFullscreenExit, GraphLegend, isString }
}

})